import { useEffect, useState } from 'react';
import { db, auth } from '../../../firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { EmailAuthProvider, reauthenticateWithCredential, updateEmail, updatePassword, onAuthStateChanged, verifyBeforeUpdateEmail } from 'firebase/auth';
import '../edit_profile/membership_edit_profile.css';
import { Link } from 'react-router-dom';

const UpdateProfilePage = () => {
  // 1. Initialize state with existing data
//   const [memberData, setMemberData] = useState(null);
  const [loading, setLoading] = useState(true);

 const [formData, setFormData] = useState({
    name: '',
    address: '',
    phone: '',
    companyAdd: '',
    fieldOfWorks: '',
    experienceType: '',
    experiencePhase: ''
  });

  // --- State for Security (Email/Password) ---
  const [securityData, setSecurityData] = useState({
    currentPassword: '',
    newEmail: '',
    newPassword: ''
  });

  // Sync data into the form fields as soon as memberData arrives
 useEffect(() => {
    // 1. Listen for the login state
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          // 2. Fetch data from Firestore using the User UID
          const userRef = doc(db, "registrations", user.uid);
          const userSnap = await getDoc(userRef);

          if (userSnap.exists()) {
            setFormData({ id: userSnap.id, ...userSnap.data() });
          } else {
            console.error("No such user document!");
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        } finally {
          setLoading(false);
        }
      } else {
        // Handle case where user is not logged in
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // --- Handle General Profile Update ---
  const handleProfileUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const userRef = doc(db, "registrations", auth.currentUser.uid);
      await updateDoc(userRef, { ...formData, updatedAt: new Date() });
      alert("General profile updated successfully!");
    } catch (error) {
      alert("Error updating profile: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // --- Handle Security Update (With Re-authentication) ---
//   const handleUpdateSecurity = async (e) => {
//   e.preventDefault();
//   if (!securityData.currentPassword) return alert("Please enter current password to verify identity.");
//   if (!securityData.newEmail) return alert("New email address cannot be left blank.");
  
//   setLoading(true);
//   const user = auth.currentUser;

//   try {
//     // 1. Re-authenticate
//     const credential = EmailAuthProvider.credential(user.email, securityData.currentPassword);
//     await reauthenticateWithCredential(user, credential);

//     let emailChanged = false;

//     // 2. Update Email using the modern secure flow
//     if (securityData.newEmail.trim().toLowerCase() !== user.email.toLowerCase()) {
      
//       // 🟢 CHANGE HERE: Swap updateEmail for verifyBeforeUpdateEmail
//       await verifyBeforeUpdateEmail(user, securityData.newEmail.trim());
//       emailChanged = true;
//     }

//     // 3. Update Password if provided
//     if (securityData.newPassword && securityData.newPassword.trim() !== "") {
//       await updatePassword(user, securityData.newPassword);
//     }

//     // 4. Update Firestore
//     if (emailChanged) {
//       const userRef = doc(db, "registrations", user.uid);
//       await updateDoc(userRef, { 
//         email: securityData.newEmail.trim() 
//       });
//     }

//     let msg = "Security settings updated successfully!";
//     if (emailChanged) msg += " A verification link has been sent to your new email. The change will take full effect once verified.";
    
//     alert(msg);
//     setSecurityData(prev => ({ ...prev, currentPassword: '', newPassword: '' }));

//   } catch (error) {
//     console.error("Security update error:", error);
//     alert("Security update failed: " + error.message);
//   } finally {
//     setLoading(false);
//   }
// };

  if (loading) return <div className="loading">Loading Profile Data...</div>;

  return (
    <div className="profile-container-edit-profile">
      {/* SECTION 1: IDENTITY (READ ONLY) */}
      <div className="profile-card-edit-profile readonly-section">
        <h3>Member Identity</h3>
        <form onSubmit={handleProfileUpdate}>
          <div className="input-group-edit-profile" >
            <label>Name</label>
            <input name="name" value={formData.name} onChange={handleChange} />
          </div>
          <div className="input-group-edit-profile">
            <label>IC No</label>
            <input name="icNo" value={formData.icNo} onChange={handleChange} />
          </div>
        <div className="readonly-grid-edit-profile">
          {/* <p><strong>Name:</strong> {formData.name}</p>
          <p><strong>IC No:</strong> {formData.icNo}</p> */}
          <p><strong>PArM No:</strong> {formData.parmNo || 'N/A'}</p>
          <p><strong>CA No:</strong> {formData.caNo || 'N/A'}</p>
          <p><strong>Member Type:</strong> {formData.memberType}</p>
        </div>
        <button type="submit" className="save-btn-edit-profile" style={{ marginTop: '25px' }} disabled={loading}>Save Identity</button>
      </form>
      </div>

      {/* <div className="input-group-edit-profile" style={{ marginBottom: '15px' }}>
            <label>Name</label>
            <input name="name" value={formData.name} onChange={handleChange} />
          </div>
          <div className="input-group-edit-profile">
            <label>IC No</label>
            <input name="icNo" value={formData.icNo} onChange={handleChange} />
          </div> */}

      {/* SECTION 2: SECURITY (SEPARATE BUTTON) */}
      <div className="settings-card-edit-profile security-card">
        <h3>Login & Security</h3>
        <p className="subtitle">Click button below to update your credentials</p>
        
        {/* <form onSubmit={handleUpdateSecurity}> */}
          <div className="input-group-edit-profile">
            <label>Current Email</label>
            <input type="text" value={auth.currentUser?.email} disabled className="locked" />
          </div>

          <div className="input-group-edit-profile">
            <label>Current Password</label>
            <input 
              type="password" 
              // required 
              // placeholder="Enter current password to verify"
              value={securityData.currentPassword}
              disabled className="locked"
              // onChange={(e) => setSecurityData({...securityData, currentPassword: e.target.value})}
            />
          </div>

          {/* <hr /> */}

          {/* <div className="input-group">
            <label>New Email Address</label>
            <input 
              type="email" 
              value={securityData.newEmail}
              onChange={(e) => setSecurityData({...securityData, newEmail: e.target.value})}
            />
          </div>

          <div className="input-group">
            <label>New Password</label>
            <input 
              type="password" 
              placeholder="Leave blank to keep current"
              value={securityData.newPassword}
              onChange={(e) => setSecurityData({...securityData, newPassword: e.target.value})}
            />
          </div> */}

       
        {/* </form> */}
         <Link to="/change-email-parm">
          <button type="button" className="security-btn-edit-profile">
            Update Email Address
          </button>
        </Link>

          <a href='/forgot-password-parm'>
          <button type="submit" className="email-update-btn-edit-profile">
            Update Password
          </button>
          </a>
      </div>

      {/* SECTION 3: EDITABLE PROFILE DATA */}
      <div className="profile-card-edit-profile">
        <h3>Contact & Professional Details</h3>
        <form onSubmit={handleProfileUpdate}>
          <div className="input-group-edit-profile">
            <label>Phone Number</label>
            <input name="phone" value={formData.phone} onChange={handleChange} />
          </div>
          <div className="input-group-edit-profile">
            <label>Residential Address</label>
            <textarea name="address" value={formData.address} onChange={handleChange} />
          </div>
          <div className="input-group-edit-profile">
            <label>Company Address</label>
            <textarea name="companyAdd" value={formData.companyAdd} onChange={handleChange} />
          </div>
          <div className="edit-grid-edit-profile">
            <div className="input-group-edit-profile">
              <label>Field of Works</label>
              <input name="fieldOfWorks" value={formData.fieldOfWorks} onChange={handleChange} />
            </div>
            <div className="input-group-edit-profile">
              <label>Experience Type</label>
              <input name="experienceType" value={formData.experienceType} onChange={handleChange} />
            </div>
            <div className="input-group-edit-profile">
              <label>Experience Phase</label>
              <input name="experiencePhase" value={formData.experiencePhase} onChange={handleChange} />
            </div>
          </div>
          <button type="submit" className="save-btn-edit-profile" disabled={loading}>Save Contact & Professional Details</button>
        </form>
      </div>
    </div>
  );
};
export default UpdateProfilePage;